import React, { createContext, useState } from 'react';
import contentState, {ContentStateType} from "../state/ContentState";


export type ContentContextType = {
    contentState: ContentStateType;
    // false until the CMS fetch settles (success or failure); undefined counts as loaded.
    contentLoaded?: boolean;
};

const ContentContext = React.createContext<ContentContextType>({
    contentState: contentState,
});

export default ContentContext;